import React from 'react';
import { View, Text } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import DropdownMenu from '@/components/General/DropdownMenu';
import Unicon from '@/components/General/Unicon';

export default function FundPicker({ funds = [], selectedFundID, onSelect, placeholder = 'Select a fund', testID = 'fund-picker', appearance = null }) {
    const selected = funds.find((f) => f.id === selectedFundID);
    const options = funds.map((f) => ({
        name: f.name,
        onSelect: () => onSelect?.(f.id),
    }));

    return (
        <View style={styles.container} testID={testID}>
            <DropdownMenu
                testID={`${testID}-dropdown`}
                title="Select a fund"
                options={options}
                triggerComponent={
                    <View style={[styles.trigger, appearance?.inputColor && { backgroundColor: appearance.inputColor }]}>
                        <Text style={[styles.triggerText, appearance?.textColor && { color: appearance.textColor }, !selected && styles.placeholder]} numberOfLines={1}>
                            {selected?.name || placeholder}
                        </Text>
                        <Unicon name="chevron-down" size={18} color={appearance?.textColor ? `${appearance.textColor}B3` : null} colorVariant="textSecondary" />
                    </View>
                }
            />
        </View>
    );
}

const styles = StyleSheet.create(({ colors, fonts, spacing, roundness }) => ({
    container: {
        flex: 1,
    },
    trigger: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingVertical: spacing.sm,
        paddingHorizontal: spacing.md,
        borderRadius: roundness.sm,
        backgroundColor: colors.surfaceVariant,
        gap: spacing.sm,
    },
    triggerText: {
        flex: 1,
        fontSize: 15,
        fontFamily: fonts.body,
        color: colors.text,
    },
    placeholder: {
        color: colors.textTertiary,
    },
}));
